module.exports = __webpack_public_path__ + "images/interview-UnitedHealth_Group-2.svg";